export default __webpack_public_path__ + "../staticImages/sprite-hermesshoplogo-2x.png";